import { render, staticRenderFns } from "./SanteDeces.vue?vue&type=template&id=6916af8e&"
import script from "./SanteDeces.vue?vue&type=script&lang=js&"
export * from "./SanteDeces.vue?vue&type=script&lang=js&"
import style0 from "./SanteDeces.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports